import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Button, Grid, Image, Text } from '@geist-ui/react'

export default function NoTransactionCode() {
  const { logout } = useAuth0()
  const handleLogout = () => {
    logout({ returnTo: window.location.origin })
  }

  return (
    <Grid.Container justify="center" width="100%" gap={1}>
      <Grid direction="column" style={{ textAlign: 'center' }}>
        <Image
          style={{ margin: '0 auto 20px' }}
          width="200px"
          src="/images/WaterPro_Logo_Color.png"
        />
        <Text h2>Your account may still be in the process of setting up.</Text>
        <Text p style={{ margin: '0 0 40px' }}>
          If you experience this error after 5 minutes, please contact support.
        </Text>
        <Button onClick={handleLogout}>Back to login</Button>
      </Grid>
    </Grid.Container>
  )
}
